export default __webpack_public_path__ + "static/media/Saya_casual.33bb3d33.png";